module.exports = __webpack_public_path__ + "static/media/rain.b008b5ad.svg";